<template>
    <v-container v-if="bot_allow_crm">
        <v-card>
            <v-card-title>
                <span class="headline">{{$t('sessionReportConfig')|capitalize}}</span>
            </v-card-title>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-combobox
                                v-model="select"
                                :items="items"
                                :label="$t('fieldToReport')|capitalize"
                                multiple
                                chips
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                        :key="JSON.stringify(data.item)"
                                        :selected="data.selected"
                                        :disabled="data.disabled"
                                        class="v-chip--select-multi"
                                        @input="data.parent.selectItem(data.item)"
                                >
                                    <v-avatar
                                            class="accent white--text"
                                            v-text="data.item.slice(0, 1).toUpperCase()"
                                    ></v-avatar>
                                    {{ data.item }}
                                </v-chip>
                            </template>
                        </v-combobox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <div class="text-xs-right">
                            <v-btn color="#4977EE" class="add-custom-info" @click="updateBtn()">
                                {{$t('update')|capitalize}}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import BotService from "@/services/bot.service";

export default {
        name: "CRMAttributeConfig",
        props: {
            botCode: String
        },
        data() {
            return {
                select: [],
                items: [],
                bot_allow_crm: false
            }
        },
        mounted() {
            if (this.botCode) {
                this.getCRMCollection();
                this.getSessionReportConfig();
            }
        },
        watch: {
            botCode() {
                if (this.botCode) {
                    this.getCRMCollection();
                    this.getSessionReportConfig();
                }
            },
        },
        methods: {
            getCRMCollection() {
                BotService.getCRMCollection(this.botCode)
                    .then((res) => {
                        let customerAttributes = res.data;
                        this.bot_allow_crm = res.data.bot_allow_crm;
                        this.items = []
                        this.items = [..._.keys(customerAttributes.built_in), ..._.keys(customerAttributes.attributes)];
                    })
            },
            getSessionReportConfig() {
                BotService.getSessionReportConfig(this.botCode).then((res) => {
                    this.select = res.data.config_data
                }).catch(() => {
                    this.$AppService.handleRequestError("Update session report config failed")
                })
            },
            updateBtn() {
                BotService.saveSessionReportConfig(this.botCode,this.select)
                    .then(() => {
                        this.$AppService.toastSuccess("Update session report config success")
                    })
                    .catch(() => {
                        this.$AppService.handleRequestError("Update session report config failed")
                    })
            }
        }
    }
</script>

<style scoped>
    ::v-deep .v-card {
        border-radius: 4px !important;
    }

    .add-custom-info {
        color: #FFFFFF;
        text-transform: none;
        font-weight: bold;
        border-radius: 5px !important;
        margin-left: 0px !important;
    }

    .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }
</style>
